'use client';

import config from '@/app/[locale]/wallet/components/commons/config';
import PrizeData from './PrizeData';
import RedeemSection from './RedeemSection';
import { useRedeemSection } from './useRedeemSection';
import Image from 'next/image';

import type { JSX } from "react";

interface Props {
  id: number;
  imageUrl: string;
  points: number;
  name: string;
  description: string;
}

const PrizeDetail = (props: Props): JSX.Element => {
  const [isAuth, missingLoyaltyPoints] = useRedeemSection(props.points);

  return (
    <div className="pb-8 sm:container sm:mx-auto sm:pb-12 sm:pt-4 sm:px-4 lg:px-6 xl:px-8">
      <div className="grid sm:grid-cols-2 sm:gap-4 md:gap-6">
        <div className="sticky" style={{ top: `calc( ${config.NAVBAR_HEIGHT} + 1.5rem)` }}>
          <div className="relative w-full aspect-square">
            <Image
              fill
              src={props.imageUrl}
              alt={props.name}
              className="sm:rounded-lg sticky"
            />
          </div>
        </div>
        <div>
          <PrizeData name={props.name} description={props.description} />
          <RedeemSection
            points={props.points}
            prizeId={props.id}
            isAuth={isAuth}
            missingPoints={missingLoyaltyPoints}
          />
        </div>
      </div>
    </div>
  );
};

export default PrizeDetail;
